exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sideContent{-webkit-box-shadow:2px 0 6px rgba(0,21,41,0.35);box-shadow:2px 0 6px rgba(0,21,41,0.35)\n}\n", "", {"version":3,"sources":["/opt/fh-web/firmiana-hpc-website-main/src/views/firmiana/layout/sliderWhich.vue"],"names":[],"mappings":";AACA,aAAa,gDAAgD,uCAAuC;CACnG","file":"sliderWhich.vue","sourcesContent":["\n.sideContent{-webkit-box-shadow:2px 0 6px rgba(0,21,41,0.35);box-shadow:2px 0 6px rgba(0,21,41,0.35)\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ad84786","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/firmiana/layout/sliderWhich.vue
// module id = 0+pn
// module chunks = 148